import { QueryKeys } from "@app/constants/query-keys.ts";
import { useApis } from "@app/data/apis.ts";
import { UtilizationCodePostModel } from "@app/data/engine.ts";
import { handleApiError } from "@app/helpers/error-helper.tsx";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useQuery } from "bi-lib";
import { toast } from "react-toastify";

interface Props {
    id?: number;
}

export default function useSetupUtilizationCodesData({ id }: Props = {}) {
    const apis = useApis();
    const queryClient = useQueryClient();

    const getSortedUtilizationCodeQuery = useQuery({
        queryKey: [QueryKeys.GetSortedUtilizationCode],
        queryFn: () => apis.engine.setupApi.setupApiGetSortedUtilizationCodeList(),
    });

    const getUtilizationCodeQuery = useQuery({
        queryKey: [QueryKeys.GetUtilizationCode, { id }],
        queryFn: () => apis.engine.setupApi.setupApiGetUtilizationCodeList({ id }),
        enabled: id != undefined,
    });

    const saveUtilizationCodeMutation = useMutation({
        mutationFn: (post: UtilizationCodePostModel) => apis.engine.setupApi.setupApiSaveUtilizationCodeCreate(post),
        onSuccess: (_, { utilizationCodeId }) => {
            void queryClient.invalidateQueries({ queryKey: [QueryKeys.GetSortedUtilizationCode] });
            void queryClient.invalidateQueries({
                queryKey: [QueryKeys.GetUtilizationCode, { id: utilizationCodeId }],
            });
            toast.success("Utilization code saved");
        },
        onError: (error: Error) => handleApiError(error, "Failed to save utilization code"),
    });

    return {
        utilizationCodes: getSortedUtilizationCodeQuery,
        utilizationCode: getUtilizationCodeQuery,

        saveUtilizationCode: saveUtilizationCodeMutation,
    };
}
